<div class="title">
    <span>  {{data.title}} </span>
    <i class="close-icon" mat-button cdkFocusInitial [mat-dialog-close]="false"></i>
</div>

<pre *ngIf="!data.renderAsHtml">
{{ data.text }}
</pre>

<!-- HTML (opt-in) -->
<div *ngIf="data.renderAsHtml" class="help-html" [innerHTML]="data.text"></div>
